import { removeLengthUnitFromCssVar } from "../utilities/helper-function";

class StudioNotificationBanner {
    constructor(element) {
        this.studioNotificationBanner = element;
        this.previousElementSiblings = [];
        this.rootStyles = getComputedStyle(document.documentElement);
        this.headerHeight= removeLengthUnitFromCssVar(this.rootStyles.getPropertyValue('--header-top-height').trim());
        this.headerHeightDesktop= removeLengthUnitFromCssVar(this.rootStyles.getPropertyValue('--header-top-height-desktop').trim());
        this.breakPoint = 1200;

        window.addEventListener('load', () => {
            this.getPreviousElements();
            this.adjustBannerTopPosition();
        });

        window.addEventListener('resize', () => {
            this.adjustBannerTopPosition();
        })
    }

    getPreviousElements() {
        let el = this.studioNotificationBanner.previousElementSibling;

        if(el == null) return;

        while(el) {
            this.previousElementSiblings.push(el);
            el = el.previousElementSibling;
        }
    }

    adjustBannerTopPosition() {
        let totalHeight = 0;
        this.previousElementSiblings.forEach((el) => {
            totalHeight += el.scrollHeight;
        })

        if(window.innerWidth >= this.breakPoint) {
            this.studioNotificationBanner.style.top = (totalHeight + parseInt(this.headerHeightDesktop)) + "px";
        } else {
            this.studioNotificationBanner.style.top = (totalHeight + parseInt(this.headerHeight)) + "px";
        }
    }
}

export default StudioNotificationBanner;